'use client'
import { api } from '@/shared/api/client-api'
import { API_END_POINTS } from '@/shared/api/end-points'
import { methods } from '@/shared/api/constants'
import { ChangePasswordDto } from '../../lib'
import { objectToFormData } from '@/shared/lib/helpers/object-methods'

const changePassword = async (data: ChangePasswordDto) => {
  const res = await api.json<string>(API_END_POINTS.auth.changePassword, {
    method: methods.post,
    body: objectToFormData({ ...data, action: 'newpass' }),
    headers: {
      accept: '*/*',
      'cache-control': 'max-age=0',
    },
    mode: 'cors',
    credentials: 'include',
  })

  return res
}

export default changePassword
